import { BaseResource } from "./base.resource";

export const FacilityAccessLevel = {
  None: 0,
  View: 1 << 0,
  Edit: 1 << 1,
  Delete: 1 << 2,
};

export class Facility extends BaseResource {
  company: string;
  address: string;
  phone: string;
  epaid: string;
  facilityName: string;
  facilityTypeName: string;
  twsOk: boolean;
  twsCheckDate: Date;
  active: boolean;

  constructor(options?: any) {
    super(options);
    // Initialize properties...
  }

  get canView(): boolean {
    return (this.accessLevel & FacilityAccessLevel.View) > 0;
  }
  get canEdit(): boolean {
    return (this.accessLevel & FacilityAccessLevel.Edit) > 0;
  }
  get canDelete(): boolean {
    return (this.accessLevel & FacilityAccessLevel.Delete) > 0;
  }
}
